import React from 'react';

const TaIndicatorConfigFormModal = React.lazy(() => import('../components/FormModal'));
const taIndicatorConfigModalRegistry = {
    personalize_taIndicatorConfigId: TaIndicatorConfigFormModal
};
export default taIndicatorConfigModalRegistry;
